import Vue from "vue";
import App from "./views/App.vue";

// Plugins
import router from "./router";
import store from "./store";
import Buefy from "buefy";
import VueSnackbar from "vue-snack";
import { snackConfig } from "./services/snack";
import Vuelidate from "vuelidate";
import money from "v-money";
import VueTailwindColorPicker from "vue-tailwind-color-picker";

// Global Imports
import "../js/components/globals/_import";
import "../sass/app.scss";

// Utils
import { hasRole, hasPermission } from "./utils/can";

Vue.config.productionTip = false;

Vue.use(Buefy, {
  defaultIconPack: "fas",
  defaultContainerElement: "#content",
});
Vue.use(VueTailwindColorPicker);
Vue.use(VueSnackbar, snackConfig);
Vue.use(Vuelidate);
Vue.use(money, {
  precision: 4,
});

Vue.prototype.$hasRole = hasRole;
Vue.prototype.$hasPermission = hasPermission;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
